"use client";

import { MapPin, Phone, Clock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function VisitUsTodaySection() {
  const {
    ref: mapRef,
    isVisible: mapVisible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const {
    ref: phoneRef,
    isVisible: phoneVisible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const {
    ref: addressRef,
    isVisible: addressVisible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const {
    ref: hoursRef,
    isVisible: hoursVisible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const {
    ref: headingRef,
    isVisible: headingVisible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  return <section className="bg-background py-16 px-6 md:px-12 lg:px-20">
      <div className="max-w-7xl mx-auto">
        <div ref={headingRef} className={`text-center mb-12 transition-all duration-[var(--duration-medium)] ${headingVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
          <h2 className="text-3xl sm:text-4xl font-display font-bold text-foreground mb-4">Visit Our Raleigh-Durham Location</h2>
          <p className="text-lg text-foreground/80 max-w-3xl mx-auto">Smart Buy Appliances is your trusted source for new or scratch and dent appliances in the Raleigh-Durham area. We offer new and lightly used appliances at steep discounts on premium brands, with convenient delivery throughout the Triangle region.</p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center">
          {}
          <div ref={mapRef} className={`relative rounded-lg overflow-hidden shadow-medium border border-border transition-opacity duration-[var(--duration-slow)] ${mapVisible ? "opacity-100" : "opacity-0"}`}>
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1418843/img/store_location_map.png" alt="Store location map" className="w-full h-80 object-cover" />
          </div>

          {}
          <div className="space-y-8">
            {}
            <div ref={phoneRef} className={`space-y-4 transition-all duration-[var(--duration-medium)] ${phoneVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
              <div className="flex items-center gap-3">
                <div className="flex items-center justify-center size-12 rounded-full bg-primary-light">
                  <Phone className="size-6 text-primary" />
                </div>
                <div>
                  <p className="text-sm text-muted-foreground font-medium">Call us now</p>
                  <Link to="tel:+19197030041" className="text-2xl font-display font-bold text-foreground hover:text-primary transition-colors duration-[var(--duration-fast)]">
                    (919) 703-0041
                  </Link>
                </div>
              </div>
              <Link to="tel:+19197030041" className="inline-block">
                <Button size="lg" className="btn-primary hover:scale-105 active:scale-100 transition-transform duration-[var(--duration-medium)]">
                  <Phone className="size-5" />
                  Call Now
                </Button>
              </Link>
            </div>

            {}
            <div ref={addressRef} className={`space-y-3 transition-all duration-[var(--duration-medium)] delay-100 ${addressVisible ? "translate-x-0 opacity-100" : "-translate-x-8 opacity-0"}`}>
              <div className="flex items-start gap-3">
                <div className="flex items-center justify-center size-12 rounded-full bg-secondary-light shrink-0">
                  <MapPin className="size-6 text-secondary" />
                </div>
                <div>
                  <p className="text-sm text-muted-foreground font-medium mb-1">Visit our store</p>
                  <p className="text-lg text-foreground leading-relaxed">
                    4100 Atlantic Ave.<br />
                    Raleigh, NC 27604
                  </p>
                  
                </div>
              </div>
            </div>

            {}
            <div ref={hoursRef} className={`space-y-3 transition-all duration-[var(--duration-medium)] delay-200 ${hoursVisible ? "translate-x-0 opacity-100" : "-translate-x-8 opacity-0"}`}>
              <div className="flex items-start gap-3">
                <div className="flex items-center justify-center size-12 rounded-full bg-accent-light shrink-0">
                  <Clock className="size-6 text-accent" />
                </div>
                <div>
                  <p className="text-sm text-muted-foreground font-medium mb-1">Business hours</p>
                  <p className="text-lg text-foreground leading-relaxed">
                    Monday - Saturday: 10AM - 6PM<br />
                    Sunday: 12PM - 5PM
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}